
import React from "react";
import logo from "./savationChristLogo.png";

import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  Svg,
  Circle,
  Rect,
  Line,
  Polygon,
  Ellipse,
} from "@react-pdf/renderer";

/* ==========================================================================
   SAVATION IN CHRIST 
   Professional Student Assessment PDF
   Navy blue • Champagne gold
   A4 portrait • Compact essay spacing • Multi-page support
   ========================================================================== */

const C = {
  navy: "#082B4C",
  navyLight: "#17496F",
  navyPale: "#EDF3F8",
  gold: "#CBA454",
  goldPale: "#FBF5E8",
  white: "#FFFFFF",
  ink: "#202D3B",
  muted: "#586B7D",
  border: "#D6E0E9",
  surface: "#F7F9FC",
  soft: "#EDF1F5",
  orange: "#C17A22",
};

const styles = StyleSheet.create({
  /* PAGE */

  page: {
    paddingTop: 20,
    paddingBottom: 43,
    paddingHorizontal: 34,
    backgroundColor: C.white,
    fontFamily: "Helvetica",
    color: C.ink,
  },

  /* SCHOOL HEADER */

  header: {
    flexDirection: "row",
    alignItems: "center",
    paddingBottom: 8,
    borderBottomWidth: 1.5,
    borderBottomColor: C.gold,
  },

  logoFrame: {
    width: 53,
    height: 53,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: C.gold,
    padding: 3,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
    backgroundColor: C.white,
  },

  logo: {
    width: 44,
    height: 44,
    objectFit: "contain",
  },

  schoolInfo: {
    flex: 1,
  },

  schoolName: {
    fontSize: 14,
    fontWeight: "bold",
    color: C.navy,
    marginBottom: 2,
  },

  schoolLevels: {
    fontSize: 8,
    color: C.gold,
    fontWeight: "bold",
    letterSpacing: 0.55,
    marginBottom: 4,
  },

  schoolContact: {
    fontSize: 7,
    color: C.muted,
    lineHeight: 1.35,
  },

  brandLabel: {
    marginTop: 4,
    alignSelf: "flex-start",
    backgroundColor: C.navyPale,
    borderRadius: 3,
    paddingVertical: 2,
    paddingHorizontal: 5,
    fontSize: 6.5,
    fontWeight: "bold",
    color: C.navy,
    letterSpacing: 0.5,
  },

  /* EXAM BANNER */

  // examBanner: {
  //   marginTop: 9,
  //   paddingVertical: 8,
  //   paddingHorizontal: 11,
  //   backgroundColor: C.navy,
  //   borderRadius: 5,
  //   borderLeftWidth: 3,
  //   borderLeftColor: C.gold,
  //   flexDirection: "row",
  //   alignItems: "center",
  //   justifyContent: "space-between",
  // },

  // examBannerInfo: {
  //   flex: 1,
  //   paddingRight: 8,
  // },

  // examEyebrow: {
  //   color: "#E9D7AC",
  //   fontSize: 6.5,
  //   fontWeight: "bold",
  //   letterSpacing: 0.8,
  //   marginBottom: 3,
  // },

  // examTitle: {
  //   color: C.white,
  //   fontSize: 10,
  //   fontWeight: "bold",
  //   lineHeight: 1.3,
  // },

  // examMarksBox: {
  //   minWidth: 73,
  //   alignItems: "center",
  //   backgroundColor: C.gold,
  //   borderRadius: 4,
  //   paddingVertical: 5,
  //   paddingHorizontal: 7,
  // },

  // examMarksLabel: {
  //   fontSize: 6,
  //   color: C.navy,
  //   fontWeight: "bold",
  //   marginBottom: 2,
  // },

  // examMarks: {
  //   fontSize: 11,
  //   fontWeight: "bold",
  //   color: C.navy,
  // },

  examBanner: {
  marginTop: 9,
  paddingVertical: 8,
  paddingHorizontal: 11,
  backgroundColor: "#F8F9FA",
  borderRadius: 5,
  borderLeftWidth: 3,
  borderLeftColor: C.gold,
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
},

examEyebrow: {
  color: C.navy,
  fontSize: 6.5,
  fontWeight: "bold",
  letterSpacing: 0.8,
  marginBottom: 3,
},

examTitle: {
  color: C.navy,
  fontSize: 10,
  fontWeight: "bold",
  lineHeight: 1.3,
},

examMarksBox: {
  minWidth: 73,
  alignItems: "center",
  backgroundColor: "#E9ECEF",
  borderRadius: 4,
  paddingVertical: 5,
  paddingHorizontal: 7,
},

examMarksLabel: {
  fontSize: 6,
  color: C.navy,
  fontWeight: "bold",
  marginBottom: 2,
},

examMarks: {
  fontSize: 11,
  fontWeight: "bold",
  color: C.navy,
},

  paperTitle: {
    textAlign: "center",
    fontSize: 12,
    fontWeight: "bold",
    color: C.navy,
    marginTop: 9,
    marginBottom: 2,
    letterSpacing: 0.5,
  },

  paperSubtitle: {
    textAlign: "center",
    fontSize: 7.5,
    color: C.muted,
    marginBottom: 7,
  },

  /* CANDIDATE INFORMATION */

  candidatePanel: {
    borderWidth: 0.8,
    borderColor: C.border,
    borderRadius: 5,
    backgroundColor: C.surface,
    paddingHorizontal: 9,
    paddingTop: 6,
    paddingBottom: 2,
    marginBottom: 7,
  },

  candidateHeading: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 5,
    paddingBottom: 4,
    borderBottomWidth: 0.7,
    borderBottomColor: C.border,
  },

  candidateHeadingLeft: {
    flexDirection: "row",
    alignItems: "center",
  },

  candidateAccent: {
    width: 3,
    height: 10,
    backgroundColor: C.gold,
    borderRadius: 2,
    marginRight: 5,
  },

  candidateHeadingText: {
    fontSize: 7.5,
    fontWeight: "bold",
    color: C.navy,
    letterSpacing: 0.45,
  },

  candidateHeadingNote: {
    fontSize: 6.5,
    color: C.muted,
  },

  candidateGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
  },

  infoItem: {
    width: "50%",
    paddingRight: 7,
    paddingBottom: 5,
  },

  infoItemFull: {
    width: "100%",
    paddingRight: 0,
  },

  infoLabel: {
    fontSize: 6.2,
    color: C.muted,
    textTransform: "uppercase",
    letterSpacing: 0.35,
    marginBottom: 1.5,
  },

  infoValue: {
    fontSize: 8,
    lineHeight: 1.2,
    color: C.ink,
    fontWeight: "bold",
  },

  studentName: {
    color: C.navy,
    fontSize: 9,
  },

  studentNameLine: {
    height: 13,
    borderBottomWidth: 0.7,
    borderBottomColor: "#AAB8C7",
    marginRight: 8,
  },

  examDateLine: {
    height: 12,
    borderBottomWidth: 0.7,
    borderBottomColor: "#AAB8C7",
    marginRight: 8,
  },

  /* GENERAL INSTRUCTIONS */

  directionBox: {
    backgroundColor: C.goldPale,
    borderWidth: 0.8,
    borderColor: "#E8D9B8",
    borderLeftWidth: 3,
    borderLeftColor: C.gold,
    borderRadius: 4,
    paddingVertical: 7,
    paddingHorizontal: 9,
    marginBottom: 8,
  },

  directionTitle: {
    fontSize: 7.5,
    fontWeight: "bold",
    color: C.navy,
    marginBottom: 3,
  },

  directionText: {
    fontSize: 8.5,
    lineHeight: 1.45,
    color: C.ink,
  },

  /* QUESTION SECTIONS */

  sectionHeader: {
    backgroundColor: C.navy,
    paddingVertical: 5,
    paddingHorizontal: 9,
    marginTop: 4,
    marginBottom: 4,
    borderLeftWidth: 3,
    borderLeftColor: C.gold,
    borderRadius: 3,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  sectionTitle: {
    flex: 1,
    paddingRight: 8,
    color: C.white,
    fontSize: 8,
    fontWeight: "bold",
  },

  sectionMarks: {
    color: "#F2D99E",
    fontSize: 7.5,
    fontWeight: "bold",
  },

  /* COMPACT QUESTION SPACING */

  question: {
    marginBottom: 1,
    paddingBottom: 0,
  },

  questionRow: {
    flexDirection: "row",
    alignItems: "flex-start",
  },

  questionNumber: {
    width: 23,
    flexShrink: 0,
    fontSize: 9,
    lineHeight: 1.3,
    fontWeight: "bold",
    color: C.navy,
  },

  questionBody: {
    flex: 1,
  },

  questionText: {
    fontSize: 9.5,
    lineHeight: 1.3,
    color: C.ink,
  },

  questionMarks: {
    alignSelf: "flex-end",
    marginTop: 1,
    marginBottom: 0,
    fontSize: 7,
    color: C.muted,
    fontWeight: "bold",
  },

  /* MULTIPLE-CHOICE OPTIONS */

  optionsGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 3,
    marginLeft: 23,
    paddingVertical: 3,
    paddingHorizontal: 6,
    backgroundColor: C.surface,
    borderRadius: 3,
    borderWidth: 0.6,
    borderColor: C.border,
  },

  option: {
    width: "50%",
    paddingVertical: 2,
    paddingRight: 6,
    fontSize: 8.5,
    lineHeight: 1.3,
    color: C.ink,
  },

  /* ANSWER LINES */

  answerLines: {
    marginTop: 3,
    marginLeft: 23,
  },

  answerLine: {
    height: 21,
    borderBottomWidth: 0.6,
    borderBottomColor: "#C5CFD9",
  },

  /* COMPACT ESSAY ANSWER SPACE */

  essayAnswerSpace: {
    height: 5,
    marginTop: 1,
    marginLeft: 23,
    marginBottom: 0,
  },

  paragraphAnswerSpace: {
    height: 8,
    marginTop: 1,
    marginLeft: 23,
    marginBottom: 0,
  },

  trueFalseRow: {
    flexDirection: "row",
    marginTop: 3,
    marginLeft: 23,
  },

  trueFalseOption: {
    width: 90,
    fontSize: 8.5,
    color: C.ink,
  },

  drawingBox: {
    height: 140,
    borderWidth: 0.8,
    borderColor: C.border,
    borderRadius: 4,
    marginTop: 5,
    marginLeft: 23,
    backgroundColor: C.white,
  },

  /* STRUCTURED CONTENT */

  structuredContent: {
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    marginTop: 2,
  },

  structuredText: {
    fontSize: 9.5,
    lineHeight: 1.3,
    color: C.ink,
    marginBottom: 2,
  },

  structuredBlock: {
    width: "100%",
    marginTop: 2,
    marginBottom: 3,
    padding: 6,
    borderWidth: 0.7,
    borderColor: C.border,
    borderRadius: 4,
    backgroundColor: C.surface,
  },

  formulaText: {
    fontFamily: "Courier",
    fontSize: 10,
    lineHeight: 1.4,
    color: C.navy,
  },

  fractionContainer: {
    alignSelf: "flex-start",
    alignItems: "center",
    justifyContent: "center",
    marginVertical: 3,
    marginLeft: 23,
    paddingHorizontal: 10,
  },

  fractionNumerator: {
    fontFamily: "Times-Roman",
    fontSize: 12,
    textAlign: "center",
    paddingHorizontal: 8,
    paddingBottom: 2,
    color: C.ink,
  },

  fractionLine: {
    width: 75,
    borderBottomWidth: 1,
    borderBottomColor: C.navy,
  },

  fractionDenominator: {
    fontFamily: "Times-Roman",
    fontSize: 12,
    textAlign: "center",
    paddingHorizontal: 8,
    paddingTop: 2,
    color: C.ink,
  },

  graphTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: C.navy,
    textAlign: "center",
    marginBottom: 4,
  },

  graphAxisLabel: {
    fontSize: 8,
    color: C.ink,
  },

  shapeWrapper: {
    alignSelf: "center",
    maxWidth: "100%",
    marginTop: 3,
    marginBottom: 3,
    padding: 6,
    borderWidth: 0.7,
    borderColor: C.border,
    borderRadius: 4,
    backgroundColor: C.white,
    alignItems: "center",
  },

  shapeLabel: {
    fontSize: 9,
    color: C.ink,
  },

  shapeCaption: {
    fontSize: 7,
    fontWeight: "bold",
    color: C.muted,
    marginTop: 3,
  },

  questionImage: {
    maxWidth: "100%",
    maxHeight: 170,
    objectFit: "contain",
    marginTop: 4,
    marginBottom: 4,
  },

  /* TABLES */

  table: {
    width: "100%",
    marginTop: 3,
    marginBottom: 3,
    borderWidth: 0.8,
    borderColor: C.border,
    borderRadius: 3,
    overflow: "hidden",
  },

  tableRow: {
    flexDirection: "row",
  },

  tableCell: {
    flex: 1,
    paddingVertical: 4,
    paddingHorizontal: 5,
    fontSize: 8,
    lineHeight: 1.3,
    color: C.ink,
    borderRightWidth: 0.6,
    borderRightColor: C.border,
    borderBottomWidth: 0.6,
    borderBottomColor: C.border,
  },

  /* FIXED FOOTER */

  footer: {
    position: "absolute",
    bottom: 16,
    left: 34,
    right: 34,
    borderTopWidth: 0.8,
    borderTopColor: C.border,
    paddingTop: 5,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  footerText: {
    fontSize: 6.5,
    color: C.muted,
  },

  footerBrand: {
    fontSize: 6.5,
    fontWeight: "bold",
    color: C.navy,
  },
});

/* ==========================================================================
   HELPERS
   ========================================================================== */

const formatDate = (date) => {
  if (!date) return "Not specified";

  const parsed = new Date(date);

  if (Number.isNaN(parsed.getTime())) {
    return String(date);
  }

  return parsed.toLocaleString();
};

const formatDuration = (duration) => {
  if (
    duration === null ||
    duration === undefined ||
    duration === ""
  ) {
    return "Not specified";
  }

  if (
    typeof duration === "number" ||
    /^\d+(\.\d+)?$/.test(String(duration))
  ) {
    const minutes = Number(duration);

    if (Number.isFinite(minutes)) {
      if (minutes < 60) {
        return `${minutes} minute${minutes === 1 ? "" : "s"}`;
      }

      const hours = Math.floor(minutes / 60);
      const remainder = minutes % 60;

      return remainder
        ? `${hours} hr ${remainder} min`
        : `${hours} hour${hours === 1 ? "" : "s"}`;
    }
  }

  return String(duration);
};

const renderAnswerLines = (count) => (
  <View style={styles.answerLines}>
    {Array.from({ length: count }, (_, index) => (
      <View key={index} style={styles.answerLine} />
    ))}
  </View>
);

const parseStructuredPayload = (payload) => {
  if (!payload) return null;

  if (typeof payload === "string") {
    try {
      return JSON.parse(payload);
    } catch {
      return {
        blocks: [{ type: "text", text: payload }],
      };
    }
  }

  return payload;
};

const getBlocks = (payload) => {
  const content = parseStructuredPayload(payload);

  if (!content) return [];

  if (Array.isArray(content)) return content;

  return (
    content.blocks ||
    content.structured_content?.blocks ||
    content.content?.blocks ||
    []
  );
};

/* ==========================================================================
   MATHEMATICS, CHEMISTRY, GRAPHS, GEOMETRY, TABLES AND IMAGES
   ========================================================================== */

const renderMathBlock = (block, index) => (
  <View key={index} style={styles.structuredBlock}>
    <Text style={styles.formulaText}>
      {block.latex || block.expression || block.value || ""}
    </Text>
  </View>
);

const renderFractionBlock = (block, index) => (
  <View key={index} style={styles.fractionContainer}>
    <Text style={styles.fractionNumerator}>
      {block.numerator || ""}
    </Text>
    <View style={styles.fractionLine} />
    <Text style={styles.fractionDenominator}>
      {block.denominator || ""}
    </Text>
  </View>
);

const renderChemistryBlock = (block, index) => (
  <View key={index} style={styles.structuredBlock}>
    <Text style={styles.formulaText}>
      {block.formula || block.value || block.expression || ""}
    </Text>
  </View>
);

const getGraphPoints = (block) => {
  if (Array.isArray(block.data)) {
    return block.data
      .map((point) => ({
        x: Number(point.x),
        y: Number(point.y),
      }))
      .filter(
        (point) =>
          Number.isFinite(point.x) &&
          Number.isFinite(point.y)
      );
  }

  if (typeof block.data_text === "string") {
    return block.data_text
      .split("\n")
      .map((line) => {
        const [x, y] = line.split(",");

        return {
          x: Number(x),
          y: Number(y),
        };
      })
      .filter(
        (point) =>
          Number.isFinite(point.x) &&
          Number.isFinite(point.y)
      );
  }

  return [];
};

const renderGraphBlock = (block, index) => {
  const points = getGraphPoints(block);
  const width = 420;
  const height = 230;
  const padding = 38;

  const xs = points.map((p) => p.x);
  const ys = points.map((p) => p.y);

  const minX = xs.length ? Math.min(...xs) : 0;
  const maxX = xs.length ? Math.max(...xs) : 10;
  const minY = ys.length ? Math.min(...ys) : 0;
  const maxY = ys.length ? Math.max(...ys) : 10;

  const rangeX = maxX - minX || 1;
  const rangeY = maxY - minY || 1;

  const mapX = (x) =>
    padding + ((x - minX) / rangeX) * (width - 2 * padding);

  const mapY = (y) =>
    height -
    padding -
    ((y - minY) / rangeY) * (height - 2 * padding);

  return (
    <View key={index} style={styles.structuredBlock}>
      {block.title && (
        <Text style={styles.graphTitle}>{block.title}</Text>
      )}

      <Svg
        width="100%"
        height={height}
        viewBox={`0 0 ${width} ${height}`}
      >
        <Line
          x1={padding}
          y1={padding}
          x2={padding}
          y2={height - padding}
          stroke={C.navy}
          strokeWidth={1.3}
        />

        <Line
          x1={padding}
          y1={height - padding}
          x2={width - padding}
          y2={height - padding}
          stroke={C.navy}
          strokeWidth={1.3}
        />

        {points.slice(0, -1).map((point, i) => (
          <Line
            key={`line-${i}`}
            x1={mapX(point.x)}
            y1={mapY(point.y)}
            x2={mapX(points[i + 1].x)}
            y2={mapY(points[i + 1].y)}
            stroke={C.orange}
            strokeWidth={2}
          />
        ))}

        {points.map((point, i) => (
          <Circle
            key={`point-${i}`}
            cx={mapX(point.x)}
            cy={mapY(point.y)}
            r={3}
            fill={C.navy}
          />
        ))}

        {block.x_axis && (
          <Text
            x={width / 2}
            y={height - 5}
            textAnchor="middle"
            style={styles.graphAxisLabel}
          >
            {block.x_axis}
          </Text>
        )}

        {block.y_axis && (
          <Text
            x={12}
            y={height / 2}
            textAnchor="middle"
            style={styles.graphAxisLabel}
          >
            {block.y_axis}
          </Text>
        )}
      </Svg>
    </View>
  );
};

const renderCommonShapeLabels = (block, width, height) => {
  const labels = block.labels || {};
  const dimensions = block.dimensions || {};

  return (
    <>
      {labels.top && (
        <Text
          x={width / 2}
          y={14}
          textAnchor="middle"
          style={styles.shapeLabel}
        >
          {labels.top}
        </Text>
      )}

      {labels.left && (
        <Text
          x={10}
          y={height / 2}
          style={styles.shapeLabel}
        >
          {labels.left}
        </Text>
      )}

      {labels.right && (
        <Text
          x={width - 10}
          y={height / 2}
          textAnchor="end"
          style={styles.shapeLabel}
        >
          {labels.right}
        </Text>
      )}

      {labels.bottom && (
        <Text
          x={width / 2}
          y={height - 5}
          textAnchor="middle"
          style={styles.shapeLabel}
        >
          {labels.bottom}
        </Text>
      )}

      {labels.center && (
        <Text
          x={width / 2}
          y={height / 2}
          textAnchor="middle"
          style={styles.shapeLabel}
        >
          {labels.center}
        </Text>
      )}

      {dimensions.top && (
        <Text
          x={width / 2}
          y={30}
          textAnchor="middle"
          style={styles.shapeLabel}
        >
          {dimensions.top}
        </Text>
      )}

      {dimensions.left && (
        <Text
          x={24}
          y={height / 2 + 18}
          style={styles.shapeLabel}
        >
          {dimensions.left}
        </Text>
      )}

      {dimensions.right && (
        <Text
          x={width - 24}
          y={height / 2 + 18}
          textAnchor="end"
          style={styles.shapeLabel}
        >
          {dimensions.right}
        </Text>
      )}

      {dimensions.bottom && (
        <Text
          x={width / 2}
          y={height - 12}
          textAnchor="middle"
          style={styles.shapeLabel}
        >
          {dimensions.bottom}
        </Text>
      )}
    </>
  );
};

const renderShapeBlock = (block, index) => {
  const originalWidth = Number(block.width) || 320;
  const originalHeight = Number(block.height) || 220;

  const scale = Math.min(
    360 / originalWidth,
    240 / originalHeight,
    1
  );

  const width = Math.max(100, Math.round(originalWidth * scale));
  const height = Math.max(100, Math.round(originalHeight * scale));

  const stroke = block.stroke || C.navy;
  const strokeWidth = Math.min(
    Math.max(Number(block.stroke_width) || 2, 1),
    4
  );

  const fill =
    block.fill && block.fill !== "transparent"
      ? block.fill
      : "none";

  const type = block.shape_type || block.shape || "rectangle";
  const rotation = Number(block.rotation) || 0;

  return (
    <View key={index} style={styles.shapeWrapper}>
      <Svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
      >
        <Svg
          x={0}
          y={0}
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          transform={`rotate(${rotation} ${width / 2} ${height / 2})`}
        >
          {type === "triangle" && (
            <Polygon
              points={`${width / 2},22 22,${height - 24} ${width - 22},${height - 24}`}
              stroke={stroke}
              strokeWidth={strokeWidth}
              fill={fill}
            />
          )}

          {type === "rectangle" && (
            <Rect
              x={20}
              y={20}
              width={width - 40}
              height={height - 40}
              stroke={stroke}
              strokeWidth={strokeWidth}
              fill={fill}
            />
          )}

          {type === "square" && (
            <Rect
              x={(width - Math.min(width, height)) / 2 + 10}
              y={(height - Math.min(width, height)) / 2 + 10}
              width={Math.min(width, height) - 20}
              height={Math.min(width, height) - 20}
              stroke={stroke}
              strokeWidth={strokeWidth}
              fill={fill}
            />
          )}

          {type === "circle" && (
            <Circle
              cx={width / 2}
              cy={height / 2}
              r={Math.min(width, height) / 2 - 24}
              stroke={stroke}
              strokeWidth={strokeWidth}
              fill={fill}
            />
          )}

          {type === "ellipse" && (
            <Ellipse
              cx={width / 2}
              cy={height / 2}
              rx={width / 2 - 24}
              ry={height / 2 - 24}
              stroke={stroke}
              strokeWidth={strokeWidth}
              fill={fill}
            />
          )}

          {type === "line" && (
            <Line
              x1={24}
              y1={height / 2}
              x2={width - 24}
              y2={height / 2}
              stroke={stroke}
              strokeWidth={strokeWidth}
            />
          )}

          {type === "angle" && (
            <>
              <Line
                x1={40}
                y1={height - 36}
                x2={width / 2}
                y2={36}
                stroke={stroke}
                strokeWidth={strokeWidth}
              />

              <Line
                x1={width / 2}
                y1={36}
                x2={width - 40}
                y2={height - 36}
                stroke={stroke}
                strokeWidth={strokeWidth}
              />

              {block.angle_label && (
                <Text
                  x={width / 2}
                  y={height / 2 + 12}
                  textAnchor="middle"
                  style={styles.shapeLabel}
                >
                  {block.angle_label}
                </Text>
              )}
            </>
          )}

          {type === "parallel_lines" && (
            <>
              <Line
                x1={32}
                y1={height / 2 - 28}
                x2={width - 32}
                y2={height / 2 - 28}
                stroke={stroke}
                strokeWidth={strokeWidth}
              />

              <Line
                x1={32}
                y1={height / 2 + 28}
                x2={width - 32}
                y2={height / 2 + 28}
                stroke={stroke}
                strokeWidth={strokeWidth}
              />
            </>
          )}

          {type === "perpendicular_lines" && (
            <>
              <Line
                x1={width / 2}
                y1={24}
                x2={width / 2}
                y2={height - 24}
                stroke={stroke}
                strokeWidth={strokeWidth}
              />

              <Line
                x1={24}
                y1={height / 2}
                x2={width - 24}
                y2={height / 2}
                stroke={stroke}
                strokeWidth={strokeWidth}
              />
            </>
          )}

          {renderCommonShapeLabels(block, width, height)}

          {type === "circle" && block.radius && (
            <Text
              x={width / 2}
              y={height / 2 + 24}
              textAnchor="middle"
              style={styles.shapeLabel}
            >
              r = {block.radius}
            </Text>
          )}

          {type === "circle" && block.diameter && (
            <Text
              x={width / 2}
              y={height - 24}
              textAnchor="middle"
              style={styles.shapeLabel}
            >
              d = {block.diameter}
            </Text>
          )}
        </Svg>
      </Svg>

      <Text style={styles.shapeCaption}>
        {type.toUpperCase()}
      </Text>
    </View>
  );
};

const renderTableBlock = (block, index) => (
  <View key={index} style={styles.table}>
    {(block.rows || []).map((row, rowIndex) => {
      const cells = Array.isArray(row) ? row : row.cells || [];

      return (
        <View key={rowIndex} style={styles.tableRow}>
          {cells.map((cell, cellIndex) => (
            <Text
              key={cellIndex}
              style={[
                styles.tableCell,
                rowIndex === 0 && {
                  backgroundColor: C.navyPale,
                  color: C.navy,
                  fontWeight: "bold",
                },
              ]}
            >
              {typeof cell === "object"
                ? cell?.text || cell?.value || ""
                : String(cell ?? "")}
            </Text>
          ))}
        </View>
      );
    })}
  </View>
);

const renderStructuredContent = (payload) => {
  const blocks = getBlocks(payload);

  if (!blocks.length) return null;

  return (
    <View style={styles.structuredContent}>
      {blocks.map((block, index) => {
        if (!block) return null;

        const type =
          block.type ||
          block.kind ||
          block.element ||
          block.content_type;

        if (type === "text" || type === "paragraph") {
          return (
            <Text key={index} style={styles.structuredText}>
              {block.text || block.content || block.value || ""}
            </Text>
          );
        }

        if (
          [
            "math",
            "mathematical_expression",
            "equation",
            "latex",
          ].includes(type)
        ) {
          return renderMathBlock(block, index);
        }

        if (type === "fraction") {
          return renderFractionBlock(block, index);
        }

        if (
          ["chemistry", "chemical_formula"].includes(type)
        ) {
          return renderChemistryBlock(block, index);
        }

        if (type === "graph") {
          return renderGraphBlock(block, index);
        }

        if (
          ["shape", "geometry", "geometric_shape"].includes(type)
        ) {
          return renderShapeBlock(block, index);
        }

        if (type === "table") {
          return renderTableBlock(block, index);
        }

        if (type === "image") {
          const source =
            block.src || block.url || block.image || block.data;

          if (!source) return null;

          return (
            <Image
              key={index}
              src={source}
              style={styles.questionImage}
            />
          );
        }

        return (
          <Text key={index} style={styles.structuredText}>
            {block.text || block.content || block.value || ""}
          </Text>
        );
      })}
    </View>
  );
};

/* ==========================================================================
   QUESTION RENDERER
   ========================================================================== */

const renderQuestionText = (question, questionIndex) => {
  const text = question.question_text || "";

  return (
    <View style={styles.questionRow}>
      <Text style={styles.questionNumber}>
        {questionIndex + 1}.
      </Text>

      <View style={styles.questionBody}>
        {text ? (
          <Text style={styles.questionText}>{text}</Text>
        ) : null}

        {question.structured_payload
          ? renderStructuredContent(question.structured_payload)
          : null}
      </View>
    </View>
  );
};

/* ==========================================================================
   STUDENT TEST PAPER
   ========================================================================== */

const renderStudentPage = (test, student, studentIndex) => {
  const studentName =
    student?.full_name ||
    student?.student_name ||
    student?.name ||
    "";

  const sections = Array.isArray(test.sections) ? test.sections : [];

  return (
    <Page
      key={student?.id || studentIndex}
      size="A4"
      style={styles.page}
      wrap
    >
      {/* SCHOOL IDENTITY */}

      <View style={styles.header}>
        <View style={styles.logoFrame}>
          <Image src={logo} style={styles.logo} />
        </View>

        <View style={styles.schoolInfo}>
          <Text style={styles.schoolName}>
            Salvation In Christ School System - SICSS
          </Text>

          <Text style={styles.schoolLevels}>
           KINGDOM GARDEN • ELEMENTARY • JUNIOR HIGH • SENIOR HIGH SCHOOL
          </Text>

          <Text style={styles.schoolContact}>
            Zazay Community, Paynesville City, Monrovia
          </Text>

          <Text style={styles.schoolContact}>
            {/* +231-886909466 / +231-770123025 */}
            Equipping for a Better Future
          </Text>

          <Text style={styles.brandLabel}>
            OFFICIAL STUDENT ASSESSMENT
          </Text>
        </View>
      </View>

      {/* TEST IDENTITY */}

      <View style={styles.examBanner}>
        <View style={styles.examBannerInfo}>
          <Text style={styles.examEyebrow}>
            ACADEMIC ASSESSMENT
          </Text>

          <Text style={styles.examTitle}>
            {test.subject_name || "Subject"}
            {"  •  "}
            {test.period_name || "Test"}
          </Text>
        </View>

        <View style={styles.examMarksBox}>
          <Text style={styles.examMarksLabel}>
            TOTAL MARKS
          </Text>

          <Text style={styles.examMarks}>
            {test.total_marks ?? 0}
          </Text>
        </View>
      </View>

      <Text style={styles.paperTitle}>
        STUDENT TEST PAPER
      </Text>

      <Text style={styles.paperSubtitle}>
        Read all questions carefully before answering.
      </Text>

      {/* CANDIDATE DETAILS */}

      <View style={styles.candidatePanel} wrap={false}>
        <View style={styles.candidateHeading}>
          <View style={styles.candidateHeadingLeft}>
            <View style={styles.candidateAccent} />

            <Text style={styles.candidateHeadingText}>
              CANDIDATE INFORMATION
            </Text>
          </View>

          <Text style={styles.candidateHeadingNote}>
            Complete before starting
          </Text>
        </View>

        <View style={styles.candidateGrid}>
          <View style={[styles.infoItem, styles.infoItemFull]}>
            <Text style={styles.infoLabel}>Student Name</Text>

            {studentName ? (
              <Text style={[styles.infoValue, styles.studentName]}>
                {studentName}
              </Text>
            ) : (
              <View style={styles.studentNameLine} />
            )}
          </View>

          <View style={styles.infoItem}>
            <Text style={styles.infoLabel}>Grade / Class</Text>

            <Text style={styles.infoValue}>
              {test.grade_class_name || "________________"}
            </Text>
          </View>

          <View style={styles.infoItem}>
            <Text style={styles.infoLabel}>Subject</Text>

            <Text style={styles.infoValue}>
              {test.subject_name || "________________"}
            </Text>
          </View>

          <View style={styles.infoItem}>
            <Text style={styles.infoLabel}>Academic Period</Text>

            <Text style={styles.infoValue}>
              {test.period_name || "________________"}
            </Text>
          </View>

          <View style={styles.infoItem}>
            <Text style={styles.infoLabel}>Test Duration</Text>

            <Text style={styles.infoValue}>
              {formatDuration(test.duration)}
            </Text>
          </View>

          <View style={styles.infoItem}>
            <Text style={styles.infoLabel}>Start Time</Text>

            <Text style={styles.infoValue}>
              {test.start_time
                ? formatDate(test.start_time)
                : "____________"}
            </Text>
          </View>

          <View style={styles.infoItem}>
            <Text style={styles.infoLabel}>End Time</Text>

            <Text style={styles.infoValue}>
              {test.end_time
                ? formatDate(test.end_time)
                : "____________"}
            </Text>
          </View>

          <View style={[styles.infoItem, styles.infoItemFull]}>
            <Text style={styles.infoLabel}>Examination Date</Text>

            <View style={styles.examDateLine} />
          </View>
        </View>
      </View>

      {/* GENERAL INSTRUCTIONS */}

      {test.direction ? (
        <View style={styles.directionBox} wrap={false}>
          <Text style={styles.directionTitle}>
            GENERAL INSTRUCTIONS
          </Text>

          <Text style={styles.directionText}>
            {test.direction}
          </Text>
        </View>
      ) : null}

      {/* SECTIONS AND QUESTIONS */}

      {sections.map((section, sectionIndex) => {
        const questionType = String(
          section.question_type || "Questions"
        )
          .replace(/_/g, " ")
          .toUpperCase();

        return (
          <View key={section.id || sectionIndex}>
            <View style={styles.sectionHeader} wrap={false}>
              <Text style={styles.sectionTitle}>
                SECTION {sectionIndex + 1} {" — "} {questionType}
              </Text>

              <Text style={styles.sectionMarks}>
                {section.allocated_marks ?? 0} MARKS
              </Text>
            </View>

            {(section.questions || []).map(
              (question, questionIndex) => (
                <View
                  key={question.id || questionIndex}
                  style={styles.question}
                >
                  {renderQuestionText(question, questionIndex)}

                  <Text style={styles.questionMarks}>
                    ({question.marks ?? 0}{" "}
                    {Number(question.marks) === 1 ? "mark" : "marks"})
                  </Text>

                  {question.question_image_base64 ? (
                    <Image
                      src={question.question_image_base64}
                      style={styles.questionImage}
                    />
                  ) : null}

                  {section.question_type === "multiple_choice" ? (
                    <View style={styles.optionsGrid}>
                      {[
                        ["A", question.option_a],
                        ["B", question.option_b],
                        ["C", question.option_c],
                        ["D", question.option_d],
                      ].map(([letter, option]) => (
                        <Text key={letter} style={styles.option}>
                          {letter}. {option || ""}
                        </Text>
                      ))}
                    </View>
                  ) : null}

                  {section.question_type === "fill_blank"
                    ? renderAnswerLines(1)
                    : null}

                  {/* Compact essay answer space */}

                  {section.question_type === "essay" ? (
                    <View style={styles.essayAnswerSpace} />
                  ) : null}

                  {/* Compact paragraph answer space */}

                  {section.question_type === "paragraph" ? (
                    <View style={styles.paragraphAnswerSpace} />
                  ) : null}

                  {section.question_type === "short_answer"
                    ? renderAnswerLines(2)
                    : null}

                  {section.question_type === "true_false" ? (
                    <View style={styles.trueFalseRow}>
                      <Text style={styles.trueFalseOption}>
                        [  ] TRUE
                      </Text>

                      <Text style={styles.trueFalseOption}>
                        [  ] FALSE
                      </Text>
                    </View>
                  ) : null}

                  {section.question_type === "drawing" ? (
                    <View style={styles.drawingBox} />
                  ) : null}
                </View>
              )
            )}
          </View>
        );
      })}

      {/* FIXED FOOTER */}

      <View style={styles.footer} fixed>
        <Text style={styles.footerBrand}>
          SICSS • STUDENT ASSESSMENT
        </Text>

        <Text
          style={styles.footerText}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
        />

        <Text style={styles.footerText}>
          Powered by Polu Integrated Technology
        </Text>
      </View>
    </Page>
  );
};

/* ==========================================================================
   PDF DOCUMENT
   ========================================================================== */

const TestPDF = ({ test, students = [] }) => {
  if (!test) {
    return (
      <Document title="Student Test Paper">
        <Page size="A4" style={styles.page}>
          <View style={styles.header}>
            <View style={styles.logoFrame}>
              <Image src={logo} style={styles.logo} />
            </View>

            <View style={styles.schoolInfo}>
              <Text style={styles.schoolName}>
                 Salvation In Christ School System - SICSS
              </Text>

              <Text style={styles.schoolLevels}>
                KINGDOMGARTEN  •  ELEMENTARY  •  JUNIOR HIGH SCHOOL • SENIOR HIGH SCHOOL
              </Text>

              <Text style={styles.schoolContact}>
                Student Assessment Records
              </Text>
            </View>
          </View>

          <View style={styles.directionBox}>
            <Text style={styles.directionTitle}>
              TEST UNAVAILABLE
            </Text>

            <Text style={styles.directionText}>
              No test data is available to generate this document.
            </Text>
          </View>
        </Page>
      </Document>
    );
  }

  const validStudents = Array.isArray(students) ? students : [];

  return (
    <Document
      title={`${test.subject_name || "Subject"} ${
        test.period_name || "Test"
      } - Student Test Paper`}
      author="Salvation In Christ School System - SICSS"
      subject="Student Test Paper"
      creator="Polu Integrated Technology"
    >
      {validStudents.length > 0
        ? validStudents.map((student, studentIndex) =>
            renderStudentPage(test, student, studentIndex)
          )
        : renderStudentPage(test, null, 0)}
    </Document>
  );
};

export default TestPDF;